import { Inject, Injectable } from '@angular/core';
import { LDClient } from 'launchdarkly-js-client-sdk';
import { WindowToken } from '../window.token';
import { ConfigurationService } from './configuration/configuration.service';
import { LDClientSDK } from './ldclientsdk.token';

enum ChromeMessageTypes {
  SET_SERVICE_HOST = 'SET_SERVICE_HOST',
  CLEAR_SERIVCE_HOST = 'CLEAR_SERIVCE_HOST',
}

@Injectable({
  providedIn: 'root',
})
export class ChromeMessagingService {
  // The ID of the extension we want to talk to.
  private extensionId: string;
  private readonly chromeExtensionServiceHost = this.ldClientSDK.variation(
    'chrome-extension-service-host',
    false
  );

  constructor(
    private configurationService: ConfigurationService,
    @Inject(WindowToken) private windowRef: Window,
    @Inject(LDClientSDK) private ldClientSDK: LDClient
  ) {
    this.extensionId = this.configurationService.ebbExtensionId;
  }

  public setExtensionServiceHost(remoteOrgHost: string = '') {
    const serviceHost = remoteOrgHost ? remoteOrgHost : this.windowRef.location.origin;
    if (this.chromeExtensionServiceHost) {
      this.sendMessage(
        ChromeMessageTypes.SET_SERVICE_HOST,
        serviceHost
      );
    }
  }

  public clearExtensionServiceHost() {
    if (this.chromeExtensionServiceHost) {
      this.sendMessage(ChromeMessageTypes.CLEAR_SERIVCE_HOST);
    }
  }

  private sendMessage(messageKey: ChromeMessageTypes, value?: any) {
    if (typeof chrome !== 'undefined' && chrome.runtime) {
      console.log('Sending message to chrome...', messageKey, value);
      let message: { message: ChromeMessageTypes; value?: any } = {
        message: messageKey,
      };
      if (value) {
        message = { ...message, value: value };
      }
      chrome.runtime.sendMessage(
        this.extensionId,
        { message },
        function (response) {
          if (!response || response.error)
            console.error(
              'Failed to send message to chrome: ' + response.error
            );
        }
      );
    } else {
      console.error('Chrome not found');
    }
  }
}
